import { render, staticRenderFns } from "./VPromiseBtn.vue?vue&type=template&id=ba08122e&lang=pug"
import script from "./VPromiseBtn.vue?vue&type=script&lang=js"
export * from "./VPromiseBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports